import { cn } from '@forest/shared'
import type { CSSProperties, ReactNode } from 'react'
import '~/styles/gradient-border.css'

type Size = number | string

export type Props = {
  children?: ReactNode
  className?: string
  style?: CSSProperties
  borderWidth?: Size
  radius: Size
  gradient?: string
}

export function GradientBorderBox({
  children,
  className,
  style,
  borderWidth = 1.5,
  radius,
  gradient = 'linear-gradient(90deg, #FFFFFF4D, #FFFFFF1A)',
}: Props) {
  const cssVars: CSSProperties = {
    ['--border-width' as any]:
      typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,
    ['--radius' as any]: typeof radius === 'number' ? `${radius}px` : radius,
    ['--gradient' as any]: gradient,
  }

  return (
    <span
      className={cn('gradient-border relative block', className)}
      style={{ ...cssVars, ...style }}
    >
      {children}
    </span>
  )
}
